module.exports = __webpack_public_path__ + "static/img/stay-option-icon-seminari.5689c02e.svg";